import { Search } from '@components/layout/toolbars/tableToolbar/search'
import { cn } from '@global/utils/tailwind'

export const Toolbar = ({ className = '', children }) => {
  return (
    <section
      className={cn(
        'flex flex-1 px-14 py-3 bg-cv-blue-100 border-y border-[#DAE2E3] gap-8',
        className,
      )}
    >
      {children}
    </section>
  )
}

const ToolbarSearch = ({ callback, onKeyPress, onChange }) => {
  return (
    <section className="flex">
      <Search onSearchCallback={callback} onKeyPress={onKeyPress} onChange={onChange} />
    </section>
  )
}

const Left = ({ children }) => {
  return <div className="flex flex-1 items-center">{children}</div>
}

const Right = ({ children }) => {
  return <div className="flex items-center">{children}</div>
}

Toolbar.Search = ToolbarSearch
Toolbar.Left = Left
Toolbar.Right = Right
